import { cn } from '@/lib/utils';
import type { HqlHighlight, HqlTokenRole } from '@rock/hql';
import type { FC } from 'react';

const ROLE_CLASSES: Record<HqlTokenRole, string> = {
    subject: 'text-sky-700',
    field: 'text-violet-700',
    function: 'text-fuchsia-700',
    keyword: 'text-rose-700',
    operator: 'text-slate-600',
    string: 'text-emerald-700',
    number: 'text-amber-700',
    value: 'text-emerald-700',
    punctuation: 'text-slate-500',
    plain: '',
};

/** Inline, a line breaks only between tokens, so a word like `early-fall` never splits at its hyphen. */
const BREAKABLE_ROLES: ReadonlySet<HqlTokenRole> = new Set(['punctuation', 'plain']);

/**
 * Read-only code, colored by what each stretch is. Inline by default, for a table cell or a sentence, where
 * it wraps or truncates as its container does; `block` for a card.
 */
export const HighlightedCode: FC<{ stretches: readonly HqlHighlight[]; block?: boolean }> = ({ stretches, block }) => {
    const Code = block ? 'pre' : 'code';
    return (
        <Code
            className={cn(
                'not-prose font-mono',
                block
                    ? 'whitespace-pre-wrap rounded-md bg-muted p-3 text-sm'
                    : 'box-decoration-clone rounded bg-muted px-1 py-0.5 text-xs',
            )}
        >
            {stretches.map((stretch, index) => (
                <span
                    key={index}
                    className={cn(
                        ROLE_CLASSES[stretch.role],
                        !block && !BREAKABLE_ROLES.has(stretch.role) && 'whitespace-nowrap',
                    )}
                >
                    {stretch.text}
                </span>
            ))}
        </Code>
    );
};
